import { Route, Routes } from "react-router";
import Layout from "./components/Layout/Layout";
import Home from "./pages/Home/Home";
import "./App.css";
import About from "./pages/About/About";
import { Faq } from "./pages/Faq/faq";
import Termsandcondition from "./pages/Termsandcondition/termsandcondition";
import Contact from "./pages/Contact/Contact";
import Account from "./pages/Account/Account";
import ShoppingCart from "./pages/ShoppingCart/ShoppingCart";
import CategoryPage from "./pages/CategoryPage/CategoryPage";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import { GoUp } from "./components/go_up_btn/Go_Up";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="About" element={<About />}></Route>
          <Route path="Faqs" element={<Faq />}></Route>
          <Route path="Account" element={<Account />}></Route>
          <Route path="OurStore" element={<CategoryPage />}></Route>
          <Route
            path="ProductDetails/:productId"
            element={<ProductDetails />}
          ></Route>
          <Route path="Cart" element={<ShoppingCart />}></Route>
          <Route
            path="Termsandcondition"
            element={<Termsandcondition />}
          ></Route>
          <Route path="Contact" element={<Contact />} />
        </Route>
      </Routes>
      <GoUp />
    </>
  );
}

export default App;
